export function getProjectTheme() {
    // TODO разобраться как расширять global
    // @ts-ignore
    return globalThis?.projectTheme;
}
export function toggleBlockScroll(value, element = document.body) {
    if (element && value) {
        element.style.overflow = 'hidden';
    }
    else {
        element.style.overflow = '';
    }
}
